<template>
  <div>
    <div class="custom-control custom-switch">
      <input 
        :placeholder="placeholder"
        type="checkbox" 
        class="custom-control-input"
        :disabled="isReadOnly" 
        :id="idInput"
        :checked="localValue"
        @change="handleChange"
      >
      <label class="custom-control-label" :for="idInput"></label>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "TheSwitchButton",
  props: {
    placeholder: String,
    isReadOnly: Boolean,
    initialValue: {
      type: [Number, Boolean, String],
      default: false,
      validator: (value) =>
        ["0", "1", "true", "false", 0, 1, true, false].includes(value),
    },
  },
  emits: ["update:initialValue","onChange"], // Declare emitted events here
  data() {
    return {
      idInput: "checkboxTable_" + Math.random().toString(36).substr(2, 9),
      localValue: this.parseBoolean(this.initialValue),
    };
  },
  methods: {
    parseBoolean(value) {
      if (typeof value === "string") {
        return value.toLowerCase() === "true";
      }
      return Boolean(value);
    },
    handleChange() {
      this.localValue = !this.localValue; // Toggle localValue
      this.$emit("update:initialValue", this.localValue); // Emit only the boolean value
      this.$emit("onChange", this.localValue); // Emit only the boolean value
    },
  },
  watch: {
    initialValue(newValue) {
      this.localValue = this.parseBoolean(newValue);
    },
  },
};
</script>
